import TemplateView from '../../../../../TemplateView'

export default class SuccessFooter extends TemplateView {

    templateHtml() {
        return '<div class="supportInfo">' +
               '    <div class="footerTitle"><%=title%></div>' +
               '</div>'
    }

    messageKeys() {
        return {
            title: 'licenses.purchase.success.footer_phrase',
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/successStep/SuccessFooter.js